import gql from "graphql-tag";


export const COMPANY_METRICS_QUERY = gql`
query todayCompanyMetric {
  todayCompanyMetric {
    label
    cohort
    total
  }
}`

export const USER_EXPORT_QUERY = gql`
  query userExport($filters: GenericScalar!) {
    userExport(filters: $filters) {
      id
      firstName
      lastName
      email
      username
      userProfile {
        id
        engagementScore
        rewardBalance
        phone
        numBulkMessagesInLast7Days
        lastSubscriptionEndDate
        coach {
          id
          firstName
          lastName
        }
        activeSubscription {
          id
          product {
            id
            type
          }
        }
        currentBlocks {
          id
          title
        }
     }
    }
  }
`;
  

